module.exports = __webpack_public_path__ + "img/51.a308a723.svg";